import React, { FC, useState } from "react";
import produce from "immer";
import { startEditElement } from "../../../../actions/elementListAction";
import { Element } from "../../../../models/elementModel";
import { Accordion, Button, Card } from "react-bootstrap";
import { ActionModel } from "../../../../models/actionModel";
import { uuid } from "uuidv4";
import { AppState } from "../../../../reducers/rootReducer";
import { useDispatch, useSelector } from "react-redux";
import { Actions, ActionTypes } from "../../../../utils/constants";
import "../elementCommonPropertiesPanal.scss";
import { CgRemoveR } from "react-icons/cg";
import Switch from "react-switch";
import { Tooltip } from "react-tippy";
import { NavigationTabs } from "../../../../models/NavigationTabsModel";
export interface ActionPropertiesProps {
  element: Element;
}

const ActionProperties: FC<ActionPropertiesProps> = ({ element }) => {
  const dispatch = useDispatch();

  const formState = useSelector((state: AppState) => state.formList);
  const elementState = useSelector((state: AppState) => state.elementList);
  const tabState = useSelector((state: AppState) => state.tabList);

  const forms = formState.filter((form) => {
    return form.type === "form" && form.id !== element.formId;
  });

  const modals = formState.filter((modal) => {
    return modal.type === "model";
  });

  const alerts = formState.filter((alert) => {
    return alert.type === "alert";
  });

  const elementsInCurrentForm = elementState.present.filter((showElemnt) => {
    return showElemnt.formId === element.formId && showElemnt.id !== element.id;
  });
  //add an action
  const addAction = () => {
    let newAction: ActionModel = {
      id: uuid(),
      action: "",
      actionType: "",
      renderComponent: "",
      externalUrl: "",
      navTabValue: "",
      navTabIsDropdown: false,
      navTabIndex: -1,
      dropdownLvl1: "",
      dropdownLvl1Index: -1,
      dropdownLvl1IsDropdown: false,
      dropdownLvl2: "",
      dropdownLvl2Index: -1,
      dropdownLvl2IsDropdown: false,
      dropdownLvl3: "",
      dropdownLvl3Index: -1,
      dropdownValue: "",
    };
    const newElement = produce(element, (draft) => {
      draft.actions.push(newAction);
    });
    dispatch(startEditElement(newElement));
  };

  //remove an selected action
  const removeAction = (index: number) => {
    const newElement = produce(element, (draft) => {
      draft.actions.splice(index, 1);
      if (draft.type === "lbl" || draft.type === "img") {
        if (draft.actions.length <= 0) draft.properties.coursorType = "";
      }
    });
    dispatch(startEditElement(newElement));
  };

  const checkElementIsTab = (id: string) => {
    const newElement = elementState.present.filter((showElemnt) => {
      return showElemnt.id === id;
    })[0];

    if (!newElement) return false;

    if (newElement.type === "tab") return true;

    return false;
  };

  const checkElementIsCollapse = (id: string) => {
    const newElement = elementState.present.filter((showElemnt) => {
      return showElemnt.id === id;
    })[0];

    if (!newElement) return false;

    if (newElement.type === "collaps") return true;

    return false;
  };

  const filterTabsFromSelectedTab = (id: string) => {
    const tabs = tabState.filter((tabs) => {
      return tabs.elementId === id;
    });
    return tabs;
  };

  //filter action type
  const filterActionTypes = () => {
    switch (element.type) {
      case "lbl":
      case "btn":
      case "img":
      case "navbar":
        return ActionTypes.filter((actionType) => {
          return (
            actionType.value !== "onChange" &&
            actionType.value !== "onChecked" &&
            actionType.value !== "onUnChecked"
          );
        });
      case "dropdown":
        return ActionTypes.filter((actionType) => {
          return (
            actionType.value !== "onClick" &&
            actionType.value !== "onChecked" &&
            actionType.value !== "onUnChecked"
          );
        });
      case "rdioBtn":
      case "chkBox":
        return ActionTypes.filter((actionType) => {
          return (
            actionType.value !== "onClick" && actionType.value !== "onChange"
          );
        });
      default:
        return ActionTypes;
    }
  };
  //filter actions
  const filterActions = (type: string) => {
    switch (type) {
      case "onChange":
        return Actions.filter((action) => {
          return action.id === 0 || action.id === 6 || action.id === 7;
        });
      case "onChecked":
      case "onUnChecked":
        return Actions.filter((action) => {
          return action.id === 0 || action.id === 6 || action.id === 7;
        });
      default:
        return Actions;
    }
  };

  //get relevent render list depend on relevent action
  const selectRenderList = (i: number) => {
    switch (element.actions[i].action) {
      case Actions[1].value:
        return forms;
      case Actions[2].value:
        return modals;
      case Actions[3].value:
        return alerts;
      case Actions[6].value:
        if (element.actions[i].actionType === "onUnChecked") {
          return elementState.present.filter((showElemnt) => {
            return (
              (showElemnt.formId === element.formId &&
                showElemnt.id !== element.id &&
                showElemnt.properties.display === true) ||
              showElemnt.type === "tab" ||
              showElemnt.type === "collaps"
            );
          });
        } else {
          return elementState.present.filter((showElemnt) => {
            return (
              (showElemnt.formId === element.formId &&
                showElemnt.id !== element.id &&
                showElemnt.properties.display === false) ||
              showElemnt.type === "tab" ||
              showElemnt.type === "collaps"
            );
          });
        }
      case Actions[7].value:
        if (element.actions[i].actionType === "onUnChecked") {
          return elementState.present.filter((showElemnt) => {
            return (
              (showElemnt.formId === element.formId &&
                showElemnt.id !== element.id &&
                showElemnt.properties.display === false) ||
              showElemnt.type === "tab" ||
              showElemnt.type === "collaps"
            );
          });
        } else {
          return elementState.present.filter((showElemnt) => {
            return (
              (showElemnt.formId === element.formId &&
                showElemnt.id !== element.id &&
                showElemnt.properties.display === true) ||
              showElemnt.type === "tab" ||
              showElemnt.type === "collaps"
            );
          });
        }
      case Actions[8].value:
        if (element.actions[i].actionType === "onUnChecked") {
          return elementState.present.filter((showElemnt) => {
            return (
              (showElemnt.formId === element.formId &&
                showElemnt.id !== element.id &&
                showElemnt.properties.display === false) ||
              showElemnt.type === "tab" ||
              showElemnt.type === "collaps"
            );
          });
        } else {
          return elementState.present.filter((showElemnt) => {
            return (
              (showElemnt.formId === element.formId &&
                showElemnt.id !== element.id &&
                showElemnt.properties.display === true) ||
              showElemnt.type === "tab" ||
              showElemnt.type === "collaps"
            );
          });
        }
      default:
        const elementList = elementState.present.filter((showElemnt) => {
          return (
            showElemnt.formId === element.formId && showElemnt.id !== element.id
          );
        });
        return elementList;
    }
  };

  return (
    <div className="flex-container">
      <div className="form-group row">
        <label htmlFor="actions" className="col-sm-12 col-form-label">
          Actions
        </label>
      </div>
      <div className="form-group col-12 m-2 p-2">
        <button
          type="button"
          className="btn btn-dark btn-sm font-size-12"
          onClick={addAction}
        >
          Create a New Action
        </button>
      </div>
      {element.actions.map((action, i) => {
        return (
          <Card className="theam-component">
            <Accordion.Toggle as={Button} variant="dark" eventKey={`${i}`}>
              <div className="row">
                <div className="col-10 theam-font">Action {i + 1}</div>
                <div className="col-2">
                  <Tooltip title="Remove Action">
                    <CgRemoveR
                      size={20}
                      onClick={(e) => {
                        e.stopPropagation();
                        removeAction(i);
                      }}
                    />
                  </Tooltip>
                </div>
              </div>
            </Accordion.Toggle>

            <Accordion.Collapse eventKey={`${i}`}>
              <Card.Body className="theam-card">
                <div className="form-group row">
                  <label
                    htmlFor="action-type"
                    className="col-sm-4 col-form-label font-size-12 align-text-left"
                  >
                    Type
                  </label>
                  <div className="col-sm-8">
                    <select
                      value={action.actionType}
                      id="action-type"
                      className="form-control theam-textbox"
                      onChange={(e) => {
                        const newElement = produce(element, (draft) => {
                          draft.actions[i].actionType = e.target.value;
                          draft.actions[i].action = "";
                          draft.actions[i].renderComponent = "";
                          draft.actions[i].dropdownValue = "";
                        });
                        dispatch(startEditElement(newElement));
                      }}
                    >
                      {filterActionTypes().map((item, i) => {
                        return (
                          <option key={i} value={item.value}>
                            {item.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                {element.type === "dropdown" && (
                  <div className="form-group row">
                    <label
                      htmlFor="action-type"
                      className="col-sm-4 col-form-label font-size-12 align-text-left"
                    >
                      Dropdown value
                    </label>
                    <div className="col-sm-8">
                      <select
                        value={action.dropdownValue}
                        id="action-type"
                        className="form-control theam-textbox"
                        onChange={(e) => {
                          const newElement = produce(element, (draft) => {
                            draft.actions[i].dropdownValue = e.target.value;
                            draft.actions[i].action = "";
                            draft.actions[i].renderComponent = "";
                          });
                          dispatch(startEditElement(newElement));
                        }}
                      >
                        <option key={0} value="">
                          --Default--
                        </option>
                        {element.properties.options.map(
                          (item: any, i: number) => {
                            return (
                              <option key={item.id} value={item.id}>
                                {item.valueText}
                              </option>
                            );
                          }
                        )}
                      </select>
                    </div>
                  </div>
                )}
                {element.type === "navbar" && (
                  <div className="form-group row">
                    <label
                      htmlFor="tab-value"
                      className="col-sm-4 col-form-label font-size-12 align-text-left"
                    >
                      Tabs
                    </label>
                    <div className="col-sm-8">
                      <select
                        value={action.navTabValue}
                        id="tab-value"
                        className="form-control theam-textbox"
                        onChange={(e) => {
                          const newElement = produce(element, (draft) => {
                            draft.actions[i].navTabValue = e.target.value;
                            draft.actions[i].navTabIsDropdown =
                              e.target.value != ""
                                ? element.properties.tabs[
                                    element.properties.tabs.findIndex(
                                      (tab: any) => tab.id == e.target.value
                                    )
                                  ].isDropdown
                                : false;
                            draft.actions[i].navTabIndex =
                              e.target.value != ""
                                ? element.properties.tabs.findIndex(
                                    (tab: any) => tab.id == e.target.value
                                  )
                                : -1;
                            draft.actions[i].dropdownLvl1 = "";
                            draft.actions[i].dropdownLvl1Index = -1;
                            draft.actions[i].dropdownLvl1IsDropdown = false;
                            draft.actions[i].dropdownLvl2 = "";
                            draft.actions[i].dropdownLvl2Index = -1;
                            draft.actions[i].dropdownLvl2IsDropdown = false;
                            draft.actions[i].dropdownLvl3 = "";
                            draft.actions[i].dropdownLvl3Index = -1;
                            draft.actions[i].dropdownValue = "";
                            draft.actions[i].action = "";
                            draft.actions[i].renderComponent = "";
                          });
                          dispatch(startEditElement(newElement));
                        }}
                      >
                        <option key={0} value="">
                          --Default--
                        </option>
                        {element.properties.tabs.map((item: any, i: number) => {
                          return (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                )}
                {action.navTabIsDropdown && (
                  <div className="form-group row">
                    <label
                      htmlFor="LVL1"
                      className="col-sm-4 col-form-label font-size-12 align-text-left"
                    >
                      Level 1
                    </label>
                    <div className="col-sm-8">
                      <select
                        value={action.dropdownLvl1}
                        id="LVL1"
                        className="form-control theam-textbox"
                        onChange={(e) => {
                          const newElement = produce(element, (draft) => {
                            draft.actions[i].dropdownLvl1 = e.target.value;
                            draft.actions[i].dropdownLvl1Index =
                              e.target.value != ""
                                ? element.properties.tabs[
                                    action.navTabIndex
                                  ].dropdown.findIndex(
                                    (dropdownLvl1: any) =>
                                      dropdownLvl1.id == e.target.value
                                  )
                                : -1;
                            draft.actions[i].dropdownLvl1IsDropdown =
                              e.target.value != ""
                                ? element.properties.tabs[action.navTabIndex]
                                    .dropdown[
                                    draft.actions[i].dropdownLvl1Index
                                  ].isDropdown
                                : false;
                            draft.actions[i].dropdownLvl2 = "";
                            draft.actions[i].dropdownLvl2Index = -1;
                            draft.actions[i].dropdownLvl2IsDropdown = false;
                            draft.actions[i].dropdownLvl3 = "";
                            draft.actions[i].dropdownLvl3Index = -1;
                            draft.actions[i].dropdownValue = "";
                            draft.actions[i].action = "";
                            draft.actions[i].renderComponent = "";
                          });
                          dispatch(startEditElement(newElement));
                        }}
                      >
                        <option key={0} value="">
                          --Default--
                        </option>
                        {element.properties.tabs[
                          element.properties.tabs.findIndex(
                            (tab: any) => tab.id == action.navTabValue
                          )
                        ].dropdown.map((lvl1Item: any) => {
                          return (
                            <option key={lvl1Item.id} value={lvl1Item.id}>
                              {lvl1Item.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                )}
                {action.dropdownLvl1IsDropdown && (
                  <div className="form-group row">
                    <label
                      htmlFor="LVL2"
                      className="col-sm-4 col-form-label font-size-12 align-text-left"
                    >
                      Level 2
                    </label>
                    <div className="col-sm-8">
                      <select
                        value={action.dropdownLvl2}
                        id="LVL2"
                        className="form-control theam-textbox"
                        onChange={(e) => {
                          const newElement = produce(element, (draft) => {
                            draft.actions[i].dropdownLvl2 = e.target.value;
                            draft.actions[i].dropdownLvl2Index =
                              e.target.value != ""
                                ? element.properties.tabs[
                                    action.navTabIndex
                                  ].dropdown[
                                    action.dropdownLvl1Index
                                  ].dropdown.findIndex(
                                    (dropdownLvl2: any) =>
                                      dropdownLvl2.id == e.target.value
                                  )
                                : -1;
                            draft.actions[i].dropdownLvl2IsDropdown =
                              e.target.value != ""
                                ? element.properties.tabs[action.navTabIndex]
                                    .dropdown[action.dropdownLvl1Index]
                                    .dropdown[
                                    draft.actions[i].dropdownLvl2Index
                                  ].isDropdown
                                : false;
                            draft.actions[i].dropdownLvl3 = "";
                            draft.actions[i].dropdownLvl3Index = -1;
                            draft.actions[i].dropdownValue = "";
                            draft.actions[i].action = "";
                            draft.actions[i].renderComponent = "";
                          });
                          dispatch(startEditElement(newElement));
                        }}
                      >
                        <option key={0} value="">
                          --Default--
                        </option>
                        {element.properties.tabs[action.navTabIndex].dropdown[
                          action.dropdownLvl1Index
                        ].dropdown.map((lvl2Item: any) => {
                          return (
                            <option key={lvl2Item.id} value={lvl2Item.id}>
                              {lvl2Item.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                )}
                {action.dropdownLvl2IsDropdown && (
                  <div className="form-group row">
                    <label
                      htmlFor="LVL3"
                      className="col-sm-4 col-form-label font-size-12 align-text-left"
                    >
                      Level 3
                    </label>
                    <div className="col-sm-8">
                      <select
                        value={action.dropdownLvl3}
                        id="LVL3"
                        className="form-control theam-textbox"
                        onChange={(e) => {
                          const newElement = produce(element, (draft) => {
                            draft.actions[i].dropdownLvl3 = e.target.value;
                            draft.actions[i].dropdownLvl3Index =
                              e.target.value != ""
                                ? element.properties.tabs[
                                    action.navTabIndex
                                  ].dropdown[action.dropdownLvl1Index].dropdown[
                                    action.dropdownLvl2Index
                                  ].dropdown.findIndex(
                                    (dropdownLvl3: any) =>
                                      dropdownLvl3.id == e.target.value
                                  )
                                : -1;
                            draft.actions[i].dropdownValue = "";
                            draft.actions[i].action = "";
                            draft.actions[i].renderComponent = "";
                          });
                          dispatch(startEditElement(newElement));
                        }}
                      >
                        <option key={0} value="">
                          --Default--
                        </option>
                        {element.properties.tabs[action.navTabIndex].dropdown[
                          action.dropdownLvl1Index
                        ].dropdown[action.dropdownLvl2Index].dropdown.map(
                          (lvl3Item: any) => {
                            return (
                              <option key={lvl3Item.id} value={lvl3Item.id}>
                                {lvl3Item.name}
                              </option>
                            );
                          }
                        )}
                      </select>
                    </div>
                  </div>
                )}
                <div className="form-group row">
                  <label
                    htmlFor="action"
                    className="col-sm-4 col-form-label font-size-12 align-text-left"
                  >
                    Action
                  </label>
                  <div className="col-sm-8">
                    <select
                      value={action.action}
                      id="action"
                      className="form-control theam-textbox"
                      onChange={(e) => {
                        const newElement = produce(element, (draft) => {
                          draft.actions[i].action = e.target.value;
                          draft.actions[i].renderComponent = "";
                        });
                        dispatch(startEditElement(newElement));
                      }}
                    >
                      {action.actionType ? (
                        filterActions(action.actionType).map((item, i) => {
                          return (
                            <option key={i} value={item.value}>
                              {item.name}
                            </option>
                          );
                        })
                      ) : (
                        <option key={0} value="">
                          --Default--
                        </option>
                      )}
                    </select>
                  </div>
                </div>
                {element.actions[i].action === Actions[5].value && (
                  <div className="form-group row">
                    <label
                      htmlFor="external-url"
                      className="col-sm-4 col-form-label font-size-12 align-text-left"
                    >
                      URL
                    </label>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        className="form-control"
                        id="external-url"
                        value={action.externalUrl}
                        onChange={(e) => {
                          const newElement = produce(element, (draft) => {
                            draft.actions[i].externalUrl = e.target.value;
                          });
                          dispatch(startEditElement(newElement));
                        }}
                      />
                    </div>
                  </div>
                )}
                {element.actions[i].action !== Actions[5].value &&
                  element.actions[i].action !== Actions[0].value && (
                    <>
                      <div className="form-group row">
                        <label
                          htmlFor="render-elemnt-id"
                          className="col-sm-4 col-form-label font-size-12 align-text-left"
                        >
                          Depends
                        </label>
                        <div className="col-sm-8">
                          <select
                            value={action.renderComponent}
                            id="render-elemnt-id"
                            className="form-control theam-textbox"
                            onChange={(e) => {
                              const newElement = produce(element, (draft) => {
                                draft.actions[i].renderComponent =
                                  e.target.value;
                              });
                              dispatch(startEditElement(newElement));
                            }}
                          >
                            <option key={0} value="">
                              --Default--
                            </option>
                            {action.action &&
                              action.action !== Actions[4].value &&
                              selectRenderList(i).length !== 0 &&
                              selectRenderList(i).map(
                                (item: any, i: number) => {
                                  return (
                                    <option key={i + 1} value={`${item.id}`}>
                                      {item.name}
                                    </option>
                                  );
                                }
                              )}
                            {action.action &&
                              action.action === Actions[4].value &&
                              elementsInCurrentForm.length !== 0 &&
                              elementsInCurrentForm.map((item, i) => {
                                return (
                                  <option key={i + 1} value={`${item.id}`}>
                                    {item.name}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                      </div>
                      {action.renderComponent &&
                        checkElementIsTab(action.renderComponent) && (
                          <>
                            {(action.action === "show" &&
                              element.properties.display === false) ||
                              (action.action === "hide" &&
                                element.properties.display === true && (
                                  <div className="form-group row">
                                    <label
                                      htmlFor="entire-tab"
                                      className="col-sm-4 col-form-label font-size-12 align-text-left"
                                    >
                                      Entire Tab
                                    </label>
                                    <div className="col-sm-2 mt-1">
                                      <Switch
                                        checked={
                                          action.entireElemet === undefined
                                            ? false
                                            : action.entireElemet
                                        }
                                        onChange={(e) => {
                                          const newElement = produce(
                                            element,
                                            (draft) => {
                                              draft.actions[i].entireElemet = e;
                                            }
                                          );
                                          dispatch(
                                            startEditElement(newElement)
                                          );
                                        }}
                                        onColor="#86d3ff"
                                        onHandleColor="#2693e6"
                                        handleDiameter={15}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                        height={10}
                                        width={24}
                                        className="react-switch"
                                        id="entire-tab"
                                      />
                                    </div>
                                  </div>
                                ))}
                            {(action.entireElemet === undefined ||
                              action.entireElemet === false) && (
                              <div className="form-group row">
                                <label
                                  htmlFor="render-tab-id"
                                  className="col-sm-4 col-form-label font-size-12 align-text-left"
                                >
                                  Tab
                                </label>
                                <div className="col-sm-8">
                                  <select
                                    value={action.tabValue}
                                    id="render-tab-id"
                                    className="form-control theam-textbox"
                                    onChange={(e) => {
                                      const newElement = produce(
                                        element,
                                        (draft) => {
                                          draft.actions[i].tabValue =
                                            e.target.value;
                                        }
                                      );
                                      dispatch(startEditElement(newElement));
                                    }}
                                  >
                                    <option key={0} value="">
                                      --Default--
                                    </option>
                                    {filterTabsFromSelectedTab(
                                      action.renderComponent
                                    ).map((item, i) => {
                                      if (action.action === "show") {
                                        if (item.display === false) {
                                          return (
                                            <option
                                              key={i}
                                              value={`${item.id}`}
                                            >
                                              {item.name}
                                            </option>
                                          );
                                        }
                                      } else if (action.action === "hide") {
                                        if (item.display === true) {
                                          return (
                                            <option
                                              key={i}
                                              value={`${item.id}`}
                                            >
                                              {item.name}
                                            </option>
                                          );
                                        }
                                      } else {
                                        return (
                                          <option key={i} value={`${item.id}`}>
                                            {item.name}
                                          </option>
                                        );
                                      }
                                    })}
                                  </select>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                    </>
                  )}
                {action.renderComponent &&
                  checkElementIsCollapse(action.renderComponent) && (
                    <>
                      {(action.action === "show" &&
                        element.properties.display === false) ||
                        (action.action === "hide" &&
                          element.properties.display === true) ||
                        (action.action === "show-hide" && (
                          <div className="form-group row">
                            <label
                              htmlFor="entire-collapse"
                              className="col-sm-4 col-form-label font-size-12 align-text-left"
                            >
                              Entire Collapse
                            </label>
                            <div className="col-sm-2 mt-1">
                              <Switch
                                checked={
                                  action.entireElemet === undefined
                                    ? false
                                    : action.entireElemet
                                }
                                onChange={(e) => {
                                  const newElement = produce(
                                    element,
                                    (draft) => {
                                      draft.actions[i].entireElemet = e;
                                    }
                                  );
                                  dispatch(startEditElement(newElement));
                                }}
                                onColor="#86d3ff"
                                onHandleColor="#2693e6"
                                handleDiameter={15}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                height={10}
                                width={24}
                                className="react-switch"
                                id="entire-collapse"
                              />
                            </div>
                          </div>
                        ))}
                      {(action.entireElemet === undefined ||
                        action.entireElemet === false) && (
                        <div className="form-group row">
                          <label
                            htmlFor="render-collapse-id"
                            className="col-sm-4 col-form-label font-size-12 align-text-left"
                          >
                            Collapse
                          </label>
                          <div className="col-sm-8">
                            <select
                              value={action.tabValue}
                              id="render-collapse-id"
                              className="form-control theam-textbox"
                              onChange={(e) => {
                                const newElement = produce(element, (draft) => {
                                  draft.actions[i].tabValue = e.target.value;
                                });
                                dispatch(startEditElement(newElement));
                              }}
                            >
                              <option key={0} value="">
                                --Default--
                              </option>
                              {filterTabsFromSelectedTab(
                                action.renderComponent
                              ).map((item, i) => {
                                return (
                                  <option key={i} value={`${item.id}`}>
                                    {item.name}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                      )}
                    </>
                  )}
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        );
      })}
      {(element.type === "lbl" || element.type === "img") &&
        element.actions.length > 0 && (
          <div className="form-group row mt-2">
            <label
              htmlFor="btn-type"
              className="col-sm-4 col-form-label font-size-12 align-text-left pr-0"
            >
              Coursor Type
            </label>
            <div className="col-sm-8">
              <select
                value={element.properties.coursorType}
                id="coursor-type"
                className="form-control theam-textbox items-align-left"
                onChange={(e) => {
                  const newElement = produce(element, (draft) => {
                    draft.properties.coursorType = e.target.value;
                  });
                  dispatch(startEditElement(newElement));
                }}
              >
                <option key={0} value="">
                  --Default--
                </option>
                <option key={1} value="context-menu">
                  Context Menu
                </option>
                <option key={2} value="help">
                  Help
                </option>
                <option key={3} value="pointer">
                  Pointer
                </option>
                <option key={4} value="progress">
                  Progress
                </option>
                <option key={5} value="wait">
                  Wait
                </option>
              </select>
            </div>
          </div>
        )}
    </div>
  );
};

export default ActionProperties;
